import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ['item', 'key', 'valueInput', 'items', 'extraKeyItem', 'extraKeyItems'];

  connect() {}

  disconnect() {}

  updateKey(event) {
    const keyValue = event.target.value;
    const index = event.target.dataset.index;
    let input = this.valueInputTargets[index]

    input.name = input.name.replace(/(\[credentials])(\[\w*])$/, (_match, p1) => `${p1}[${keyValue}]`);
  }

  addItem(event) {
    event.preventDefault();

    // Obtener el índice del nuevo elemento
    const index = this.itemTargets.length;

    // Obtener el último elemento con data-jsonform-target="item"
    const lastItemHtml = this.itemTargets[this.itemTargets.length - 1].outerHTML;

    // Reemplazar el valor de data-index
    const newItemHtml = lastItemHtml.replace(/data-index="\d+"/g, `data-index="${index}"`)
                                    .replace(/data-index='\d+'/g, `data-index='${index}'`)
                                    .replace(/value="[^"]*"/g, `value=""`);

    // Insertar el nuevo HTML con el índice modificado
    this.itemsTarget.insertAdjacentHTML('beforeend', newItemHtml);
    const newItem = this.itemsTarget.lastElementChild;
    newItem.style.opacity = 0;
    newItem.style.transition = 'opacity 0.5s';
    requestAnimationFrame(() => newItem.style.opacity = 1);
  }

  removeItem(event) {
    event.preventDefault();
    
    if (this.itemTargets.length === 1) {
      return;
    }
    
    const item = event.target.closest("[data-jsonform-target='item']");
    if (item) {
      // Apply fade-out transition
      item.style.transition = 'opacity 0.2s';
      item.style.opacity = '0';
      
      // Remove item after the transition ends
      item.addEventListener('transitionend', () => {
        item.remove();
      });
    }
  }

  addExtraKeyItem(event) {
    event.preventDefault();

    // Obtener el índice del nuevo elemento
    const index = this.extraKeyItemTargets.length;

    // Obtener el último elemento con data-jsonform-target="extraKeyItem"
    const lastExtraKeyItemHtml = this.extraKeyItemTargets[this.extraKeyItemTargets.length - 1].outerHTML;

    // Reemplazar el valor de data-index y value="cualquiercosa"
    const newExtraKeyItemHtml = lastExtraKeyItemHtml.replace(/data-index="\d+"/g, `data-index="${index}"`)
                                                    .replace(/data-index='\d+'/g, `data-index='${index}'`)
                                                    .replace(/(?<!option\s)value="[^"]*"/g, `value=""`)
                                                    .replace(/selected="[^"]*"/g, ``);

    // Insertar el nuevo HTML con el índice modificado
    this.extraKeyItemsTarget.insertAdjacentHTML('beforeend', newExtraKeyItemHtml);
    const newExtraKeyItem = this.extraKeyItemsTarget.lastElementChild;
    newExtraKeyItem.style.opacity = 0;
    newExtraKeyItem.style.transition = 'opacity 0.5s';
    requestAnimationFrame(() => newExtraKeyItem.style.opacity = 1);
  }

  removeExtraKeyItem(event) {
    event.preventDefault();
    
    if (this.extraKeyItemTargets.length === 1) {
      return;
    }
    
    const extraKeyItem = event.target.closest("[data-jsonform-target='extraKeyItem']");
    if (extraKeyItem) {
      // Apply fade-out transition
      extraKeyItem.style.transition = 'opacity 0.2s';
      extraKeyItem.style.opacity = '0';
      
      // Remove extraKeyItem after the transition ends
      extraKeyItem.addEventListener('transitionend', () => {
        extraKeyItem.remove();
      });
    }
  }
}
